import styles from './SpeedbumpModal.scss';

import { ReferencedEntry } from 'contentful';
import React from 'react';
import { useTranslation } from 'react-i18next';

import { SpeedBumpList, SpeedBumpReseller } from 'src/api/contentful/contentTypes.shop';
import { componentKey, getField, isEntry } from 'src/utils/EntryUtil';

import { CloseButton } from '../CloseButton/CloseButton';
import { SubmitButton } from '../Form/SubmitButton';
import { ModalHeader } from '../Modal/Header/ModalHeader';
import { Modal } from '../Modal/Modal';
import { useSalesChannel } from '../SalesChannel/SalesChannel';
import { SpeedbumpCell } from './SpeedbumpCell';

interface ISpeedbumpModalProps {
  entry?: ReferencedEntry<SpeedBumpList>;
  isOpen?: boolean;
  onRequestClose?: () => void;
}

export const SpeedbumpModal: React.FunctionComponent<ISpeedbumpModalProps> = ({
 entry,
 isOpen,
 onRequestClose,
}) => {
  if (!isEntry(entry)) return null;

  const { t } = useTranslation();

  const { setTrackingHost } = useSalesChannel();

  const createOnCloseFunction = (speedbumpReseller?: ReferencedEntry<SpeedBumpReseller>) => () => {
    const [ trackingHost ] = getField(getField(speedbumpReseller, 'salesChannel'), 'referrerDomains', []);
    if (trackingHost) setTrackingHost(trackingHost);

    // close modal
    if (onRequestClose) onRequestClose();
  };

  const onCloseDefault = createOnCloseFunction(getField(entry, 'wideSalesChannel'));

  return (
    <Modal
      className={styles.speedbumpModalWrapper}
      isForm
      isOpen={!!isOpen}
      onRequestClose={onCloseDefault}
    >
      <div className={styles.speedbumpModal}>
        <CloseButton onClick={onCloseDefault} />
        <div className={styles.speedbumpModalContentWrapper}>
          <section className={styles.speedbumpModalContent}>
            <div className={styles.speedbumpModalScrollableSection}>
              <ModalHeader
                heading={entry.fields.headingText}
              />
              <div className={styles.speedbumpModalCellsWrapper}> {
                (getField(entry, 'salesChannels', []))
                  .map((speedbumpReseller, index) => (
                    <SpeedbumpCell
                      key={componentKey(speedbumpReseller, index)}
                      entry={speedbumpReseller}
                      clickable
                      onClick={createOnCloseFunction(speedbumpReseller)}
                    />
                  ))}
                </div>
              </div>
          </section>
          <div className={styles.speedbumpModalFooter}>
            <SpeedbumpCell
              wide
              entry={entry.fields.wideSalesChannel}
              blurb={entry.fields.wideSalesChannelLabel}
            />
            <SubmitButton
              className={styles.continueButton}
              title={t('continue')}
              data-test="speedbump-partner-clover"
              onClick={onCloseDefault}
            >
              {t('continue')}
            </SubmitButton>
          </div>
        </div>
      </div>
    </Modal>
  );
};
